export const TRACKER_DPA_OPEN = '[DPA Alert] banner open';
export const TRACKER_DPA_CLOSE = '[DPA Alert] banner close';
export const TRACKER_DPA_SET_CONSENT = '[DPA Alert] set consent';
export const TRACKER_DPA_CLOSE_CLICK = '[DPA Alert] banner close click';

export const TRACKER_RATE_LIMIT_BANNER_OPEN = '[Rate Limit Alert] banner open';

export const TRACKER_OVERAGE_OPEN = '[Overage Alert] banner open';
export const TRACKER_OVERAGE_CLOSE = '[Overage Alert] banner close';
export const TRACKER_OVERAGE_CLOSE_CLICK = '[Overage Alert] banner close click';

export const TRACKER_VERSION_UPDATE_OPEN = '[Version Update Alert] banner open';
export const TRACKER_VERSION_UPDATE_REFRESH = '[Version Update Alert] refresh page';

export const TRACKER_FEATURE_REQUEST_BANNER_REQUEST_FEATURE =
  '[Feature Request Banner] request feature click';
export const TRACKER_EMAIL_VERIFICATION_BANNER_OPEN = '[Email Verification Reminder] banner open';
export const TRACKER_EMAIL_VERIFICATION_BANNER_CLOSE = '[Email Verification Reminder] banner close';
export const TRACKER_EMAIL_VERIFICATION_BANNER_RESEND_CLICK =
  '[Email Verification Reminder] resend click';

export const TRACKER_NEW_FEATURES_BANNER_OPEN = '[New Features Alert] banner open';
export const TRACKER_NEW_FEATURES_BANNER_CLOSE_CLICK = '[New Features Alert] banner close click';
export const TRACKER_NEW_FEATURES_BANNER_CLOSE = '[New Features Alert] banner close';
export const TRACKER_NEW_FEATURES_BANNER_VIEW_CHANGES_CLICK =
  '[New Features Alert] view changes click';

export const TRACKER_TRIAL_EXPIRY_BANNER_OPEN = '[Trial Expiry Reminder] banner open';
export const TRACKER_TRIAL_EXPIRY_BANNER_CLOSE = '[Trial Expiry Reminder] banner close';
export const TRACKER_TRIAL_EXPIRY_BANNER_CLOSE_CLICK = '[Trial Expiry Reminder] banner close click';
export const TRACKER_TRIAL_EXPIRY_SETUP_BILLING_CLICK =
  '[Trial Expiry Reminder] setup billing click';
export const TRACKER_TRIAL_EXPIRY_BANNER_SUPPORT_CLICK = '[Trial Expiry Reminder] support click';

export const TRACKER_PAYMENT_PENDING_BANNER_OPEN = '[Payment Pending] banner open';
export const TRACKER_PAYMENT_PENDING_BANNER_CLOSE = '[Payment Pending] banner close';
export const TRACKER_PAYMENT_PENDING_BANNER_CLOSE_CLICK = '[Payment Pending] banner close click';
export const TRACKER_PAYMENT_PENDING_PAY_NOW_CLICK = '[Payment Pending] pay now click';
export const TRACKER_PAYMENT_PENDING_VIEW_PENDING_INVOICES_CLICK =
  '[Payment Pending] view pending invoices click';
export const TRACKER_PAYMENT_PENDING_TO_PAYMENT_METHODS_CLICK =
  '[Payment Pending] payment methods click';
